import { useQuery } from "react-apollo";
import { SINGLE_SYSTEM_CODE_QUERY } from "../../graphql/SystemCodes/SystemCodes.graphql";

function SystemCodeLookup({ variables, ...props }) {
  const payload = useQuery(SINGLE_SYSTEM_CODE_QUERY, {
    variables
  });
  return props.children(payload);
}

export default SystemCodeLookup;
